import {BrowserRouter as Router, Link, NavLink, Route, Routes} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from "./Home/Home";
import About from "./About/About";
import { usePushNotifications } from './Components/UsePushNotifications';
import { useEffect, /* useState */ } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import AnnouncementBar from './Components/AnnouncementBar';

function App() {
	usePushNotifications();
	/* const [isNative, setIsNative] = useState(false); */

	useEffect(() => {
		// Detect if running on Capacitor (native app)
		CapacitorApp.getInfo().then(() => {
			/* setIsNative(true); */
			document.documentElement.classList.add('is-native');
		}).catch(() => {
			/* setIsNative(false); */
		});
	}, []);

  return (<HelmetProvider>
    <AnnouncementBar />

    <Router>
      <nav>
          <Link to="/" className="nav-logo-link" aria-label="Takaisinvedot etusivulle">
            <img src="/banneri-nav.png" alt="Takaisinvedot" className="nav-logo" />
          </Link>

          <div className="nav-links">
            <NavLink to="/" end className={({ isActive }) => `navLink${isActive ? ' active' : ''}`}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              <span>Etusivu</span>
            </NavLink>
            <NavLink to="/about" className={({ isActive }) => `navLink${isActive ? ' active' : ''}`}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              <span>Meistä</span>
            </NavLink>
          </div>
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/recall/:id" element={<Home />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
    </HelmetProvider>
  );
}

export default App;
